import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CountryAccessQuery } from "../graphql/queries";
import type {
  CountryAccessQueryType,
  CountryAccessQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useCountryAccessQuery = (
  options?: QueryHookOptions<
    CountryAccessQueryType,
    CountryAccessQueryVariablesType
  >
) => {
  return useQuery<CountryAccessQueryType, CountryAccessQueryVariablesType>(
    CountryAccessQuery,
    options
  );
};
